import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { FC, ReactNode, useContext, useState } from 'react';
import ReviewService from '../../services/ReviewService';
import { AuthContext } from '../../providers/AuthProvider';

interface Props {
  id: string | number;
  theme: any;
  status: string[];
  currentStatus: string;
}
export const ReviewStatus: FC<Props> = function ({ theme, currentStatus, status, id }) {
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const { hasRole } = useContext(AuthContext);

  const handleFilterStatusChange = async (event: SelectChangeEvent) => {
    const currentStatus = event.target.value;
    setSelectedStatus(currentStatus);
    if (currentStatus === '') {
      await ReviewService.saveStatus(id, 'Status');
    } else {
      await ReviewService.saveStatus(id, currentStatus);
    }
  };

  return (
    <>
      {hasRole('can-use-status') && (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
          <FormControl
            size="small"
            sx={{ minWidth: '284px', mt: theme.spacing(2) }}
          >
            <InputLabel id="status-label-filter-label">{currentStatus || 'Status'}</InputLabel>
            <Select
              labelId="status-label-filter-label"
              value={selectedStatus}
              onChange={handleFilterStatusChange}
              label={'Status'}
            >
              <MenuItem value="Status">
                <em>-</em>
              </MenuItem>
              {Array.from(status).map((statusName: string, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={statusName}
                  >
                    {statusName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      )}
    </>
  );
};
